import { hexToNumber } from './GraphApp/helpers/hexToNumber';

export const PATHLOOKUP_ADVANCED_OPTIONS_PRESET_ID_LOCAL_STORAGE =
  'graphPathLookupAdvancedOptionsPresetId';
export const PATHLOOKUP_HOST_TO_DEFAULT_GW_TYPE_LOCAL_STORAGE =
  'graphPathlookupHostToDefault';
export const PATHLOOKUP_MULTICAST_TYPE_LOCAL_STORAGE =
  'graphPathlookupMulticast';
export const PATHLOOKUP_UNICAST_TYPE_LOCAL_STORAGE = 'graphPathlookupUnicast';
export const TOOLTIP_CONTENT_WRAPPER_CLASS = 'py-lgu-2 px-lgu-6';
export const EDGE_HIGHLIGHT_THICKNESS = 4;
export const EDGE_HIGHLIGHT_COLOR = hexToNumber('#581845');
export const FOLLOWING_EDGE_HIGHLIGHT_COLOR = hexToNumber('#900C3F');
